import { Component, OnInit, OnDestroy, ViewChild, ElementRef } from '@angular/core';
import { DynamicGrid } from '../../models/dynamic.model';

import { LazyLoadEvent, MessageService } from 'primeng/api';
import { NavigationService } from '../../services/navigation.service';
import { BaseListComponent } from '../../models/base/base-list.component';
import { ListService } from '../../services/list.service';
import { ActivatedRoute } from '@angular/router';
import { LookupService } from '../../services/lookup.service';
import { RowTools, RowToolEvent } from '../../models/row-tools.model';
import { SharedService } from '../../services/shared.service';
import { AccountService } from '../../services/account.service';
import { allEnums } from '../helper/enum';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'invoice-list',
  templateUrl: 'invoice-list.component.html',
  providers: [ListService, LookupService],
  styles: [`
        :host ::ng-deep .ui-table .ui-table-thead > tr > th {
            position: -webkit-sticky;
            position: sticky;
            top: 0;
            background: #EBEBEB;
            border-bottom: 1px solid #D8D8D8;
        }
`]
})
export class InvoiceListComponent extends BaseListComponent implements OnInit, OnDestroy {
  lookups = {};
  status = null;
  invoiceId: number = null;
  showUserModal: boolean = false;
  showOrderModal: boolean = false;
  showLocationModal: boolean = false;
  showAccountingBulkEditModal: boolean = false;
  invoiceOrderNumber = null;
  isShowCheckBox: boolean = false;
  selectedRows = []
  userId: any;
  public multiSortMeta: any = [];
  @ViewChild("orderDialog", { static: false }) dialogRef: ElementRef;
  prevLazyLoadEvent: LazyLoadEvent | null = null;
  private destroy$ = new Subject<void>();

  constructor(
    protected messageService: MessageService,
    private listService: ListService,
    private navigationService: NavigationService,
    private sharedService: SharedService,
    private route: ActivatedRoute,
    private accountService: AccountService,
    private lookupService: LookupService) {
    super();

  }

  ngOnInit() {
    this.userId = +localStorage.getItem('userId');
    this.subs['editSub'] = this.navigationService.edit$.subscribe((res) => {
      this.showModal = false;
      if (res) {
        this.invoiceOrderNumber = this.sharedService.getData("invoiceOrderNumber");
        this.showOrderModal = true;
      }
    });

    this.subs['viewInvoiceSub'] = this.navigationService.viewInvoice$.subscribe((res) => {
      if (res) {
        this.showOrderModal = false;
        this.rowTools = new RowTools();
        this.rowTools.addLink('view', 'Edit');
        this.navigationService.setLeftNav(null, 'invoices');
        this.view(res);
      }
    });

    this.subs['clickBeginAccountingBulkEditButton'] = this.navigationService.clickBeginAccountingBulkEdit$.subscribe(s => {
      if (s) {
        this.showAccountingBulkEditModal = true;
      }
    });

    this.subs['accountingBulkCheckBoxSub'] = this.sharedService.accountingBulkEditCurrentStatus.subscribe((value) => {
      this.isShowCheckBox = value;
      if (!this.isShowCheckBox) {
        this.selectedRows = [];
      }
    })

    this.subs["cancelBulInvoice"] =
      this.navigationService.clickCancelBulkInvoiceButton$.subscribe(
        (value) => {
          if (value) {
            this.first = 0;
            this.invoiceId = null;
            this.load();
          }
        }
      );

    this.class = 'invoice';
    this.title = 'Invoices';

    //#region grid model

    this.model = new DynamicGrid<any>();

    //#endregion

    //#region set nav state

    this.navigationService.showTopNav(true);
    this.navigationService.setTitle(this.title);
    this.navigationService.showButton(true);
    this.navigationService.clearButton();
    this.navigationService.showFilter(true, true);

    //#endregion

    if (this.route.snapshot.url[0] != null) {
      this.status = this.route.snapshot.url[0].path;
      if (allEnums.invoiceCategoryEnum[this.status] != null) {
        this.title = 'Invoice (' + allEnums.invoiceCategoryLabels[this.status] + ')';
      }
    }

    this.route.queryParams.subscribe(p => {
      if (p['preview'] != null && p['preview'] !== '') {
        this.view(p['preview']);
      }
    });

    this.subs['filter'] = this.navigationService.filter$.subscribe(s => {
      if(this.query != s){
        this.first = 0;
      }
      this.query = s;
      this.load();
    });

    this.subs['clickOrderButton'] = this.navigationService.clickNewOrder$.subscribe(s => {
      this.addOrder();
    });

    this.subs['clickUserButton'] = this.navigationService.clickNewUser$.subscribe(s => {
      this.addUser();
    });

    this.subs['clickLocationButton'] = this.navigationService.clickNewLocation$.subscribe(s => {
      this.addLocation();
    });
    this.subs['loadList'] = this.navigationService.loadList$.subscribe(res => {
      if (res) {
        this.load();
      }
    });

    this.loadLookup('yesNoPartial');
    this.loadLookup('yesNoNull');
    this.loadLookup('paymentTerms');
    this.loadLookup('customerChargedType');
    this.loadLookup('carrierPaymentType');
    this.loadLookup('fscpaidbycustomer');
    this.loadLookup('yesnonullpaymenthold');
  }

  ngOnDestroy() {
    this.safeUnsub('clickOrderButton');
    this.safeUnsub('clickUserButton');
    this.safeUnsub('clickLocationButton');
    this.safeUnsub('filter');
    this.safeUnsub('loadList');
    this.safeUnsub('editSub');
    this.safeUnsub('viewInvoiceSub');
    this.safeUnsub('clickBeginAccountingBulkEditButton');
    this.safeUnsub('accountingBulkCheckBoxSub');
    this.safeUnsub('cancelBulInvoice')
    this.destroy$.next();
    this.destroy$.complete();
  }

  lazyLoad(e: any) {
    if (this.prevLazyLoadEvent && this.sharedService.isSameEvent(e, this.prevLazyLoadEvent)) {
      return;
    }
    setTimeout(() => {
      this.prevLazyLoadEvent = e;
      if (e.multiSortMeta !== undefined && e.multiSortMeta.length > 0) {
      e.multiSortMeta.map((sort) => {
        const sortIndex = this.multiSortMeta.findIndex((f: any) => { return f.field === sort.field; });
        if (sortIndex > -1) {
          if (this.multiSortMeta[sortIndex].order !== sort.order) {
            this.multiSortMeta[sortIndex].requireReload = true
          }
          this.multiSortMeta[sortIndex].order = sort.order;
        } else {
          this.multiSortMeta.push({ field: sort.field, order: sort.order, requireReload: true });
        }
      });

      // Check if any of colum require reload
      const requireReload = this.multiSortMeta.some((m: any) => {
        return m.requireReload;
      });

      // It will reload only when a new sort column is added or the previous one is altered
      if (requireReload) {
        this.multiSortMeta.forEach((m: any) => {
          return m.requireReload = false;
        });
        this.multiSortMeta = [...this.multiSortMeta];
        this.setGridState(e);
        this.load();

      }
    } else {
      this.setGridState(e);
      this.load();
    }
    }, 0);
  }

  setRowTools(status: string) {
    if (status) {
      if (allEnums.invoiceCategoryEnum[status]) {
        this.rowTools = new RowTools();
        this.rowTools.addLink('view', 'Edit');
      } else if (status === 'complete') {
        this.rowTools = new RowTools();
        if (this.sharedService.getPermissions('completedmoves')) {
          this.rowTools.addLink('view', 'View');
        }
        if (this.sharedService.getPermissions('completedmoves_edit')) {
          this.rowTools.addLink('edit', 'Edit');
        }
      }
    }
  }
  load() {
    this.isLoading = true;
    this.model.rows = [];

    if (this.status != null) {
      this.rowCount = this.first == 0 ? 0 : this.rowCount;
      this.listService
        .invoicesChild(
          this.status,
          this.params,
          this.query,
          this.first,
          this.rows,
          this.sortField,
          this.sortOrder,
          JSON.stringify(this.multiSortMeta),
          this.invoiceId
        )
        .pipe(takeUntil(this.destroy$))
        .subscribe((res) => {
          this.setRowTools(this.status);

          let updatedMetaData = res.body.metadata.map((data) => {
            if (
              data.key === "paymentNotes" ||
              data.key === "carrierTransportResultsList" ||
              data.key === "fscTransportResultsList"
            ) {
              data.type = "textarea";
            }
            if (data.key == "adjustmentProfit") {
              data.type = "boldtext";
            }
            return data;
          });

          let updatedResult = res.body.results.map((data) => {
            data.carrierTransportResultsList =
              data.carrierTransportResultsList?.replaceAll("\\n", "\n");
            data.fscTransportResultsList =
              data.fscTransportResultsList?.replaceAll("\\n", "\n");
            data.factoring = data.factoring ? data.factoring : null;
            data.carrierPaymentSpecialRequest =
              data.carrierPaymentSpecialRequest
                ? data.carrierPaymentSpecialRequest
                : null;
            return data;
          });
          this.loadColumns(updatedMetaData);
          this.model.rows = updatedResult;
          this.rowCount = res.body.count;
          this.prevLazyLoadEvent.first = this.first;
          if (this.isShowCheckBox) {
            if (this.model?.rows?.length > 0) {
              let row = this.model.rows.filter((r) => r.id == this.invoiceId);
              if (row != null) {
                this.selectedRows = row;
              }
            }
            this.navigationService.setBeginAccountingBulkEditButtonEnable(true);
            this.navigationService.setSubTitle(this.rowCount + " total");
          } else {
            this.navigationService.setTitleAndSub({
              title: this.title,
              subtitle: this.rowCount + " total",
            });
          }
          this.isLoading = false;
        });
    } else {
      this.listService
        .invoices(
          this.params,
          this.query,
          this.first,
          this.rows,
          this.sortField,
          this.sortOrder,
          JSON.stringify(this.multiSortMeta)
        )
        .pipe(takeUntil(this.destroy$))
        .subscribe((res) => {
          this.setRowTools(this.status);
          this.loadColumns(res.body.metadata);
          this.model.rows = res.body.results;
          this.rowCount = res.body.count;
          this.navigationService.setTitleAndSub({
            title: this.title,
            subtitle: this.rowCount + " total",
          });
          this.isLoading = false;
        });
    }
  }

  clickRowTools(event: RowToolEvent) {
    this.selection = event.item;
    switch (event.key) {
      case 'view':
        if (event.item?.isBulkUploadInvoiceActive) {
          this.messageService.add(this.toast(true, 'Invoice cannot be edited as ' + event.item?.bulkUploadInvoiceBy + ' is Bulk Editing'));
          return;
        }
        if (allEnums.invoiceCategoryEnum[this.status]) {
          this.view(event.item?.guid);
        } else if (this.status === 'complete') {
          this.viewOrder(event.item?.guid);
        }
        break;
      case 'edit':
        if (this.status == 'complete') {
          this.edit(event.item);
        }
        break;
    }
  }

  edit(row: any) {
    this.selection = row;
    this.showOrderModal = true;
  }

  view(id: string) {
    this.navigationService.setDetail('invoice', id);
  }

  viewOrder(id: string) {
    this.navigationService.setDetail('order', id);
  }

  rowChangePreview(event:any) {
    if (this.selectedRows.length > 1 && this.selectedRows.length <= 50) {
      this.navigationService.setBeginAccountingBulkEditButtonEnable(false);
    } else if (this.selectedRows.length > 50) {
      const index = this.selectedRows.findIndex((res) => res.id == event?.data?.id)
      this.selectedRows.splice(index, 1)
      this.messageService.add(this.toast(true, 'You cannot select more than 50 invoice for bulk edit'));
    } else {
      this.navigationService.setBeginAccountingBulkEditButtonEnable(true);
    }
    if (
      this.selectedRows?.length == 1 &&
      this.selectedRows[0].id == event.data.id &&
      !this.invoiceId
    ) {
      this.first = 0;
      this.invoiceId = this.selectedRows[0].id;
      this.load();
    }
    if (this.selectedRows?.length === 0) {
      this.invoiceId = null;
      this.first = 0;
      this.load();
    }
    if (this.navigationService.getNav().showRightNav) {
      this.navigationService.setRightNav('invoice', event?.data?.id);
    }
  }


  loadLookup(key: string, force: boolean = false) {
    this.lookupService
      .get(key, force)
      .pipe(takeUntil(this.destroy$))
      .subscribe((r) => {
        this.lookups[key] = r;
      });
  }

  addUser() {
    this.showOrderModal = false;
    this.showUserModal = true;
  }

  addLocation() {
    this.showOrderModal = false;
    this.showUserModal = false;
    this.showLocationModal = true;
  }

  addOrder() {
    this.selection = null;
    this.invoiceOrderNumber = null;
    this.showOrderModal = true;
    this.showUserModal = false;
  }

  revert(event){
    if (event) {
      this.load();
    }
  }

  save(closeModal = true) {
    if (closeModal) {
      this.cancel();
    }
    this.load();
  }

  cancel(orderId?:any) {
    if(typeof orderId == 'boolean' && orderId == false){
      this.showOrderModal = true;
    }
    else{
      if (this.showOrderModal && orderId?.length > 0) {
        this.accountService
          .setAllowOrdersEdit(orderId?.map((res) => res))
          .subscribe((r) => {});
      }
      this.showOrderModal = false;
    }
    this.showUserModal = false;
    this.isEditing = false;
    this.isAdding = false;
    this.isDeleting = false;
    this.showLocationModal = false;
    if ((this.showAccountingBulkEditModal || this.showModal) && orderId?.length > 0) {
      this.accountService.setAllowInvoiceEdit(orderId?.map((res) => res)).subscribe(r => {
      });
      this.showAccountingBulkEditModal = false;
    }
    this.showModal = false;
  }

  rowColor(item: any): string {
    if (item.isCanceled && item.cancelationType === 1) {
      return "rgba(250, 0, 0, 0.1)";
    } else if (item.isCanceled || item.cancelationType === 2) {
      return "#ff0000b0";
    } else if (item.colourCode) {
      return item.colourCode;
    } else {
      return null;
    }
  }
}
